export const LEGACY = "legacy";
export const MIXED = "mixed";
export const PASCAL = "pascal";
